import lodash from "lodash";
import { defineAsyncComponent } from "vue";
import { createFieldSelect } from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { callUserBankStatus, createFieldUserBank } from "./tab2.section";

const AttachmentInlineList = defineAsyncComponent(() => import("../../../../../components/attachment/AttachmentInlineList"));

export const createField = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refStatus`,
                colProp: () => ({ xs: 24, md: 20 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.userBank.refStatus"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refStatus,
                            "onUpdate:value": value => (model.refStatus = value),
                            disabled: viewOnly,
                            list: callUserBankStatus,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            ...createFieldUserBank({ props, data, key, isLoading }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
                inputRender: () => {
                    const componentProp = lodash.merge(
                        {
                            menuContext: menuContext,
                            viewOnly: viewOnly,
                            dataProp: data,
                            itemsKey: `${prefix}attachments`,
                            canCreate: !viewOnly,
                            canDelete: !viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { componentKey: "AttachmentInlineList" } })
                    );
                    return <AttachmentInlineList {...componentProp}></AttachmentInlineList>;
                }
            }
        ]
    });
};
